import { graphql, PageProps } from "gatsby";
import React, { FC } from "react";

import { GlobalLayout } from "../../components/layouts/global-layout";
import { mapLabelsByKey } from "../../contexts/labels";
import { StandardPageContext } from "../standard-page";
import { SearchPageBody } from "./search-page-body";

export type SearchPageContext = Omit<StandardPageContext, "id">;

export interface SearchPageProps extends PageProps<Queries.SearchPageQuery, SearchPageContext> {}

const SearchPage: FC<SearchPageProps> = (props) => {
  const {
    data: { allContentfulLabel, allContentfulRichTextLabel },
    pageContext: { locale, allPageNodes, localizedUrls },
  } = props;
  const labels = mapLabelsByKey(
    Array.from(allContentfulLabel.nodes),
    (value) => value ?? ""
  ) as Record<string, string>;

  const richTextLabels = mapLabelsByKey(
    Array.from(allContentfulRichTextLabel.nodes),
    (value) => value?.raw ?? ""
  );

  return (
    <GlobalLayout
      {...{ labels, richTextLabels, localizedUrls, locale }}
      pageNodes={allPageNodes ?? []}
    >
      <SearchPageBody {...props} />
    </GlobalLayout>
  );
};

export const query = graphql`
  query SearchPage($locale: String) {
    allContentfulHeaderMenu(filter: { node_locale: { eq: $locale } }) {
      nodes {
        __typename
        ...HeaderMenuData
      }
    }
    allContentfulFooter(filter: { node_locale: { eq: $locale } }) {
      nodes {
        __typename
        ...FooterData
        node_locale
      }
    }
    allContentfulLabel(filter: { node_locale: { eq: $locale } }) {
      nodes {
        node_locale
        internalName
        value
      }
    }
    allContentfulRichTextLabel(filter: { node_locale: { eq: $locale } }) {
      nodes {
        node_locale
        internalName
        value {
          raw
        }
      }
    }
  }
`;

export default SearchPage;
